import React from 'react';
import { Card } from '../components/Card';
import { Button } from '../components/Button';
import { AlertCircleIcon, LockIcon } from 'lucide-react';
interface StateScreenProps {
  onAction: () => void;
}
export function SessionExpiredScreen({
  onAction
}: StateScreenProps) {
  return <div className="min-h-screen flex items-center justify-center p-4 bg-navy" data-id="element-195">
      <Card className="w-full max-w-md p-8 text-center" data-id="element-196">
        <div className="w-12 h-12 bg-amber/10 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-197">
          <AlertCircleIcon className="w-6 h-6 text-amber" data-id="element-198" />
        </div>
        <h2 className="text-2xl font-serif text-white mb-2" data-id="element-199">
          Your session has expired
        </h2>
        <p className="text-gray-400 mb-8" data-id="element-200">
          Please log in again to continue reviewing documents.
        </p>
        <Button fullWidth onClick={onAction} data-id="element-201">
          Log In Again
        </Button>
      </Card>
    </div>;
}
export function AccessDeniedScreen({
  onAction
}: StateScreenProps) {
  return <div className="min-h-screen flex items-center justify-center p-4 bg-navy" data-id="element-202">
      <Card className="w-full max-w-md p-8 text-center" data-id="element-203">
        <div className="w-12 h-12 bg-red-500/10 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-204">
          <LockIcon className="w-6 h-6 text-red-500" data-id="element-205" />
        </div>
        <h2 className="text-2xl font-serif text-white mb-2" data-id="element-206">
          You don't have access to this case
        </h2>
        <p className="text-gray-400 mb-8" data-id="element-207">
          Contact your administrator to request access.
        </p>
        <Button fullWidth onClick={onAction} data-id="element-208">
          Back to Cases
        </Button>
      </Card>
    </div>;
}